var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg20C(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2422_3478)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9317 0.547089H39.9319V40.5361H-0.0571289V30.88V29.5154V21.2238V19.8593V11.5677V10.2032V0.547089H7.66797H9.03229H15.3926H16.7574H23.1177H24.482H30.8423H32.2071H39.9317ZM24.4822 1.91162H30.8423V10.2032H24.4822V1.91162ZM32.2071 10.2032L38.5672 10.2032V1.91162H32.2071V10.2032ZM32.2071 19.8593V11.5677L38.5672 11.5677V19.8593L32.2071 19.8593ZM38.5672 21.2238V29.5154L32.2071 29.5154V21.2238L38.5672 21.2238ZM30.8423 29.5154V21.2238H24.4822V29.5154H30.8423ZM30.8423 30.88L24.4822 30.8799V39.1715H30.8423V30.88ZM32.2071 39.1715V30.88L38.5672 30.8799V39.1715L32.2071 39.1715ZM30.8423 11.5677V19.8593H24.4822V11.5677L30.8423 11.5677ZM9.0325 1.91162H15.3926V10.2032H9.0325V1.91162ZM16.7574 10.2032L23.1175 10.2032V1.91162H16.7574V10.2032ZM15.3926 30.88V39.1715H9.0325V30.8799L15.3926 30.88ZM16.7574 29.5154L23.1175 29.5154V21.2238H16.7574V29.5154ZM15.3926 29.5154H9.0325V21.2238H15.3926V29.5154ZM16.7574 39.1715L23.1175 39.1715V30.8799L16.7574 30.88V39.1715ZM15.3926 11.5677V19.8593H9.0325V11.5677H15.3926ZM16.7574 19.8593H23.1175V11.5677L16.7574 11.5677V19.8593ZM1.3074 29.5154H7.66776V21.2238H1.3074V29.5154ZM1.3074 39.1715L7.66776 39.1715V30.8799L1.3074 30.88V39.1715ZM7.66776 10.2032H1.3074V1.91162H7.66776V10.2032ZM1.3074 19.8593H7.66776V11.5677H1.3074V19.8593Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2422_3478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.47934)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20C);
export default __webpack_public_path__ + "static/media/20c.fab733706a9d7bd8d1028f9e34d0b90b.svg";
export { ForwardRef as ReactComponent };